export const randomnumbersubstring = () => {
	// return Math.floor(100000 + Math.random() * 900000);
	const characters =
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let result = " ";
	const charactersLength = characters.length;

	function randomIntFromInterval(min: number, max: number) {
		// min and max included
		return Math.floor(Math.random() * (max - min + 1) + min);
	}
	const rndInt = randomIntFromInterval(6, 6);

	for (let i = 0; i < rndInt; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
};


export const smoothScrollTo = (sectionRef: any) => {
	if (sectionRef.current) {
		const scrollTimeout = setTimeout(() => {
			sectionRef.current &&
				sectionRef.current.scrollIntoView({ behavior: "smooth" });
		}, 800);
		return () => {
			clearTimeout(scrollTimeout);
		};
	}
};